import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "webform/store/store";

export const userPersonaSliceSelector = (state: RootState) => state.userPersona;
export const userPersonaSelector = createSelector(userPersonaSliceSelector, ({userPersonas}) => userPersonas);
export const userPersonaResponseLocaleSelector = createSelector(
    userPersonaSliceSelector,
    ({responseLocale}) => responseLocale,
);
export const userPersonaErrorSelector = createSelector(userPersonaSliceSelector, ({error}) => error);
